import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/auth/authentication.service';
import { AppSignalDataService } from 'src/app/app-signal-data.service';
import { HeaderPageSignalDataService } from '../header-page-signal-data.service';
import { RoleEnum } from '@core/models/role';
import { PerfilEnum } from '@core/models/perfil';

@Component({
  selector: 'app-menu-aside',
  templateUrl: './menu-aside.component.html',
  styleUrls: ['./menu-aside.component.scss'],
})
export class MenuAsideComponent implements OnInit {
  menuList: MenuAside[] = [
    {
      titleVb: true,
      title: 'Administrativo',
      icon: 'fi fi-rs-computer fs-5 pe-3',
      qtdNotificacoes: 5,
      permissions: [PerfilEnum.Administrador],
      url: null,
      subMenu: [
        {
          title: 'Usuário',
          titleAdditional: null,
          icon: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador],
          url: 'usuario',
        },
        {
          title: 'Cadastro de Perfil',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador],
          url: 'perfil',
        },
      ],
    },
    {
      titleVb: false,
      title: 'Cadastro',
      icon: 'fi fi-rs-form fs-5 pe-3',
      qtdNotificacoes: null,
      permissions: [RoleEnum.EntidadeLeitura,RoleEnum.PessoaLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
      url: null,
      subMenu: [
        {
          title: 'Entidades',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.EntidadeLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
          url: 'entidade'
        },
        {
          title: 'Movimentação Societária',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.MudancaEntidadeLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
          url: 'movimentacao-societaria'
        },

        {
          title: 'Pessoas',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.PessoaLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
          url: 'pessoa'
        },

        {
          title: 'Vínculos',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.VinculoLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
          url: 'vinculo'
        },

      ]
    },
    // {
    //   titleVb: true,
    //   title: 'Validação/Aprovação',
    //   icon: 'fi fi-rs-computer fs-5 pe-3',
    //   qtdNotificacoes: 5,
    //   permissions: [PerfilEnum.Administrador,PerfilEnum.Validador,PerfilEnum.Atualizador],
    //   url: null,
    //   subMenu: [
    //     {
    //       title: 'Validar Mudanças',
    //       titleAdditional: null,
    //       icon: null,
    //       qtdNotificacoes: null,
    //       subPermissions: [PerfilEnum.Administrador,PerfilEnum.Validador,PerfilEnum.Atualizador],
    //       url: 'validar-mudancas',
    //     },
    //     {
    //       title: 'Aprovar Mudanças',
    //       titleAdditional: null,
    //       qtdNotificacoes: null,
    //       subPermissions: [PerfilEnum.Administrador,PerfilEnum.Aprovador],
    //       url: 'aprovar-mudancas',
    //     }
    //   ],
    // },

    {
      titleVb: false,
      title: 'Consultas',
      icon: 'fi-rr-list-timeline',
      qtdNotificacoes: null,
      permissions: [RoleEnum.consultaLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
      url: null,
      subMenu: [
        {
          title: 'Consultas',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.consultaLeitura,PerfilEnum.Administrador,PerfilEnum.Validador],
          url: 'consulta',
        },
        {
          title: 'Gerador de Consulta',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'consulta/gerador',
        },
        {
          title: 'Diretórios',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.DiretorioConsultaEdicao,PerfilEnum.Administrador],
          url: 'consulta/diretorio',
        }
      ],
    },
    {
      titleVb: false,
      title: 'Central de Pendências',
      icon: 'fi fi-rs-search fs-5 pe-3',
      qtdNotificacoes: null,
      permissions: [PerfilEnum.Administrador,PerfilEnum.Validador, PerfilEnum.Aprovador, PerfilEnum.Atualizador],
      url: null,
      subMenu: [
        {
          title: 'Pendências',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador,PerfilEnum.Validador, PerfilEnum.Aprovador, PerfilEnum.Atualizador],
          url: 'pendencia',
        },

      ],
    },
    {
      titleVb: false,
      title: 'Relatórios',
      icon: 'fi-rr-list-timeline',
      qtdNotificacoes: null,
      permissions: [PerfilEnum.Atualizador,PerfilEnum.Administrador,PerfilEnum.Validador],
      url: null,
      subMenu: [
        {
          title: 'Sessões Ativas',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'relatorio/sessao-ativa',
        },

        {
          title: 'Histórico de Acesso de Usuários',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'relatorio/historico-acesso',
        },
        {
          title: 'Relatório de E-mails Cadastrados',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'relatorio/email',
        }

      ],
    },
    {
      titleVb: false,
      title: 'Auditoria',
      icon: 'fi fi-rs-search fs-5 pe-3',
      qtdNotificacoes: null,
      permissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
      url: null,
      subMenu: [
        {
          title: 'Auditoria de Arquivos',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'auditoria/arquivos',
        },
        {
          title: 'Auditoria do Sistema',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'auditoria/sistema',
        },
      ],
    },

    {
      titleVb: false,
      title: 'Mailling',
      icon: 'fi fi-rs-envelope fs-5 pe-3',
      qtdNotificacoes: null,
      permissions: [PerfilEnum.Administrador, PerfilEnum.Validador, PerfilEnum.Atualizador],
      url: null,
      subMenu: [
        {
          title: 'Lista de Emails',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador, PerfilEnum.Atualizador],
          url: 'lista-mailling',
        },
        {
          title: 'Lista de Endereços',
          titleAdditional: null,
          qtdNotificacoes: null,
          subPermissions: [RoleEnum.UsuarioLeitura, PerfilEnum.Administrador, PerfilEnum.Validador, PerfilEnum.Atualizador],
          url: 'lista-mailling/lista-enderecos',
        },
      ],
    },
    {
      titleVb: false,
      title: 'Parametrização',
      icon: 'fi fi-rs-settings fs-5 pe-3',
      qtdNotificacoes: null,
      permissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
      url: null,
      subMenu: [
        {
          title: 'Dominios',
          titleAdditional: null,
          icon: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'dominios',
        },
        {
          title: 'Parametrização',
          titleAdditional: null,
          icon: null,
          qtdNotificacoes: null,
          subPermissions: [PerfilEnum.Administrador, PerfilEnum.Validador],
          url: 'parametrizacao',
        },
      ],
    },
  ];

  isCollapsed: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    public appSignalDataService: AppSignalDataService,
    public headerPageSignalDataService: HeaderPageSignalDataService,
    private router: Router
  ) {}

  ngOnInit() {}
  hasPermissionForSubMenu(subMenu: SubMenu): boolean {
    const currentUserRoles = this.authenticationService.currentUserValue.roles;
    const currentUserPerfil =
      this.authenticationService.currentUserValue.perfil;

    if (currentUserRoles && currentUserPerfil) {
      return subMenu.subPermissions.some(
        (subPermission) =>
          currentUserRoles.includes(subPermission) ||
          currentUserPerfil.perfil === subPermission
      );
    }
    return false;
  }

  hasPermissionForMenu(menuAside: MenuAside): boolean {
    const currentUserRoles = this.authenticationService.currentUserValue.roles;
    const currentUserPerfil =
      this.authenticationService.currentUserValue.perfil;

    if (currentUserRoles) {
      return menuAside.permissions.some(
        (permission) =>
          currentUserRoles.includes(permission) ||
          currentUserPerfil.perfil === permission
      );
    }
    return false;
  }

  isHome() {
    this.resetHeader();
    this.router.navigate(['/home']);
  }

  onMenuItemClick(item: any, titleMenu: string, titleVb: boolean) {
    if (item.url) {
      this.resetHeader();
      this.headerPageSignalDataService.updateVbTitlePage(titleVb);
      this.headerPageSignalDataService.updateTitleMenu(titleMenu);
      this.headerPageSignalDataService.updateTitlePage(item.title);
      this.headerPageSignalDataService.updateEtapaSubTitlePage('');
      this.headerPageSignalDataService.updateSubTitlePage('');
      this.router.navigate([item.url]);
    }
  }

  toggleCollapsed() {
    this.isCollapsed = this.appSignalDataService.isCollapsedMenuAside$();
    this.isCollapsed = !this.isCollapsed;
    this.appSignalDataService.updateCollapsedMenuAside(this.isCollapsed);
  }

  resetHeader() {
    this.headerPageSignalDataService.updateVbTitlePage(false);
    this.headerPageSignalDataService.updateTitleMenu('');
    this.headerPageSignalDataService.updateTitlePage('');
    this.headerPageSignalDataService.updateEtapaSubTitlePage('');
    this.headerPageSignalDataService.updateSubTitlePage('');
  }
}

export interface MenuAside {
  titleVb: boolean;
  title: string;
  titleAdditional?: string | null;
  icon?: string | null;
  qtdNotificacoes: number | null;
  url: string | null;
  permissions: string[];
  subMenu: SubMenu[];
}

interface SubMenu {
  titleVb?: boolean;
  title: string;
  titleAdditional: string | null;
  icon?: string | null;
  qtdNotificacoes: number | null;
  subPermissions: string[];
  url: string | null;
  subMenuSecond?: SubMenuSecond[];
}

interface SubMenuSecond {
  title: string;
  titleAdditional: string | null;
  icon?: string | null;
  subSecPermissions: string[];
  qtdNotificacoes: number | null;
  url: string | null;
}
